import {
  Dialog,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
} from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const languages = ['en', 'nl', 'fr', 'de'] as const

export type Language = (typeof languages)[number]

export type RequiredLanguages = [Language, ...Language[]]

export type ReportLanguageDialogProps = {
  open: boolean
  setOpen: (open: boolean) => void
  onClose: (language: Language) => void
  languages: RequiredLanguages
}

function LanguageList({
  languages,
  onSelect,
}: Readonly<{
  languages: RequiredLanguages
  onSelect: (value: Language) => void
}>) {
  const { t } = useTranslation('common')

  return (
    <List>
      {languages.map((language) => (
        <ListItemButton key={language} onClick={() => onSelect(language)}>
          <ListItemText primary={t(`language.code.${language}`)} />
        </ListItemButton>
      ))}
    </List>
  )
}

const ReportLanguageDialog: React.FC<ReportLanguageDialogProps> = ({
  open,
  setOpen,
  onClose,
  languages,
}) => {
  const { t } = useTranslation('common')

  const handleClose = () => setOpen(false)

  const handleSelect = (language: Language) => {
    onClose(language)
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="report-language-dialog"
    >
      <DialogTitle id="report-language-dialog">
        {t('language.select')}
      </DialogTitle>

      <LanguageList languages={languages} onSelect={handleSelect} />
    </Dialog>
  )
}

export default ReportLanguageDialog
